module.exports = __webpack_public_path__ + "img/source-sans-pro-v13-latin-300italic.b0505cc4.svg";